import { useInView } from "../../hooks/useInView";

export const Reveal = ({ as: Tag = "div", className = "", style, children, delay = 0, ...rest }) => {
  const [ref, inView] = useInView({ threshold: 0.1, rootMargin: "0px 0px -40px 0px" });
  return (
    <Tag
      ref={ref}
      className={`reveal ${inView ? "revealed" : ""} ${className}`.trim()}
      style={{ transitionDelay: inView ? `${delay}ms` : "0ms", ...style }}
      {...rest}
    >
      {children}
    </Tag>
  );
};
